module.exports = __webpack_public_path__ + "static/media/terminal.ee5f9510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/terminal.svg
// module id = 102
// module chunks = 0